import React from 'react';
import { render } from 'react-dom';
import './index.css';
import App from './App';
import { googleAuth, auth } from './firebase';
import axios from 'axios';
import includes from 'lodash/includes';
import moment from 'moment';
import { LOCAL_STORAGE_TTL } from './constants';

/**
 * The re authicate interval. Call at the end of refresh token validity to renew the user acess token.
 *
 * @type {Interval}
 */
let reAuthenticateInterval = undefined;

/**
 * Reauthenticate the user to refresh his token after expiration
 *
 * @param {Object} user The authenticated user we want to reauthenticate.
 */
function reAuthenticateUser(user) {
    console.log('Reauthenticate user after token expiration');
    user.reauthenticateWithPopup(googleAuth).then(result => {
        clearInterval(reAuthenticateInterval);
        logInCallback(result, user);
    });
}

/**
 * Call after user signIn
 *
 * @param {Object}  result             The login result containing user info & access token.
 * @param {Object}  user               The authenticated user.
 * @param {boolean} isFromLocalStorage Indicates if the user has been retrieve from LocalStorage
 */
function logInCallback(result, user, isFromLocalStorage) {
    const authorizedDomains = ['demo.lumapps.com', 'lumapps.com'];
    const token = result.credential.accessToken;
    const userProfile = result.additionalUserInfo.profile;
    const axiosOption = {
        headers: { authorization: 'Bearer ' + token },
    };
    result.time = Date.now();

    if (includes(window.location.hostname, 'localhost')) {
        axiosOption.baseURL = 'http://localhost:5000/lumdash/us-central1/app';
    }

    if (includes(authorizedDomains, userProfile.hd)) {
        /*
         * As refresh token has an expiration time we have to refresh this token by reauthenticating the user in
         * order to set the new access token when retrieving data from Google service (In backend code).
         */
        const jsonUser = JSON.parse(JSON.stringify(result));

        const tokenExpirationDate =
            jsonUser.user.stsTokenManager.expirationTime;
        const timeToWaitBeforeExpiration = moment(tokenExpirationDate).diff(
            result.time
        );

        reAuthenticateInterval = setInterval(function() {
            reAuthenticateUser(user);
        }, timeToWaitBeforeExpiration);

        if (!isFromLocalStorage) {
            window.localStorage.setItem('user', JSON.stringify(jsonUser));
        }
        window.axios = axios.create(axiosOption);

        render(<App />, document.getElementById('root'));
    } else {
        render(<div>Not Allowed</div>, document.getElementById('root'));
    }
}

auth.onAuthStateChanged(user => {
    let localUser = JSON.parse(window.localStorage.getItem('user'));
    const now = Date.now();
    const hoursMillis = 1000 * 60 * 60;

    if (
        localUser &&
        localUser.time !== undefined &&
        (now - localUser.time) / hoursMillis > LOCAL_STORAGE_TTL
    ) {
        localUser = undefined;
        window.localStorage.removeItem('user');
    }

    if (localUser) {
        logInCallback(localUser, user, true);
    } else {
        if (user) {
            user.reauthenticateWithPopup(googleAuth).then(result => {
                logInCallback(result, user);
            });
        } else {
            auth.signInWithPopup(googleAuth).then(result => {
                logInCallback(result, user);
            });
        }
    }
});



// WEBPACK FOOTER //
// ./src/index.js